/**
 * ตั้งค่า Phaser ตาม PHYSICS.md §1
 *
 * เขียนพิกัดเป็น native px ล้วนที่ 1080×1920 แล้วให้ Scale Manager (FIT) แปลงให้
 * — ได้ทั้งจอจริงแนวตั้งเต็มพอดี และ iframe ในจอ present ย่อลงเองถูกต้อง
 * โดยไม่ต้องเขียนโค้ดแปลงพิกัดที่ไหนเลย
 */
import Phaser from "phaser";

import { isPixelScene, MODE_BY_SCENE, PHYS, PHYSICS_FPS, SCENE_H, SCENE_W, type SceneId } from "@py/protocol";

import { PlayerScene, type SceneOptions } from "./PlayerScene.js";

export { PlayerScene };
export type { SceneBridge, SceneOptions, SpawnRequest } from "./PlayerScene.js";

export function createGame(
  opts: SceneOptions & { parent: string },
): { game: Phaser.Game; scene: PlayerScene } {
  const scene = new PlayerScene(opts);
  const sceneId: SceneId = opts.scene;
  const platformer = MODE_BY_SCENE[sceneId] !== "topdown";

  const game = new Phaser.Game({
    // 6 WebGL context ในเบราว์เซอร์เดียวใกล้เพดานที่ browser เริ่มเวนคืน context เก่า
    // เนื้อหาเรามีแค่ background 1 ภาพ + sprite ไม่กี่ตัว Canvas2D เหลือเฟือ
    type: opts.present ? Phaser.CANVAS : Phaser.AUTO,
    parent: opts.parent,
    width: SCENE_W,
    height: SCENE_H,
    // ฉาก 0 ไม่มีภาพฉาก — UI เป็น DOM ที่อยู่ข้างหลัง canvas
    // ถ้า canvas ทึบ UI จะถูกบังหมด ถ้า DOM อยู่หน้า canvas ตัวละครจะถูกบังแทน
    transparent: sceneId === 0,
    backgroundColor: sceneId === 0 ? undefined : "#000000",
    scale: { mode: Phaser.Scale.FIT, autoCenter: Phaser.Scale.CENTER_BOTH },
    // ฉาก 1-3 เป็น pixel art · ฉาก 4-5 เป็นภาพวาดเต็มสี ห้าม nearest
    pixelArt: isPixelScene(sceneId),
    roundPixels: isPixelScene(sceneId),
    physics: {
      default: "arcade",
      arcade: {
        gravity: { x: 0, y: platformer ? PHYS.GRAVITY : 0 },
        fixedStep: true,
        fps: PHYSICS_FPS,
        debug: false,
      },
    },
    scene: [scene],
  });

  return { game, scene };
}

export { SCENE_H, SCENE_W };
